import { useDarkMode } from '../../context/DarkModeContext';

interface Props {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  hideCancel?: boolean;
}

export default function ConfirmDialog({ open, title, message, confirmLabel = 'Bestätigen', onConfirm, onCancel, hideCancel = false }: Props) {
  const { darkMode } = useDarkMode();
  if (!open) return null;

  const card = darkMode ? 'bg-slate-800 border-slate-700 text-white' : 'bg-white border-slate-200';
  const muted = darkMode ? 'text-slate-400' : 'text-slate-500';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className={`rounded-xl border shadow-xl w-full max-w-sm ${card}`}>
        <div className={`px-5 py-4 border-b ${darkMode ? 'border-slate-700' : 'border-slate-200'}`}>
          <h3 className="text-base font-semibold">{title}</h3>
        </div>
        <div className="px-5 py-4">
          <p className={`text-sm ${muted}`}>{message}</p>
        </div>
        <div className={`px-5 py-3 flex justify-end gap-2 border-t ${darkMode ? 'border-slate-700' : 'border-slate-200'}`}>
          {!hideCancel && (
            <button
              onClick={onCancel}
              className={`px-4 py-1.5 text-sm rounded-lg border transition-colors ${darkMode ? 'border-slate-600 hover:bg-slate-700' : 'border-slate-300 hover:bg-slate-50'}`}
            >
              Abbrechen
            </button>
          )}
          <button
            onClick={onConfirm}
            className="px-4 py-1.5 text-sm rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors font-medium"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
